import * as React from 'react';

import { cn } from '../lib/cn.js';

import { TableCell, TableRow } from './table.js';

const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn('animate-pulse rounded-sm bg-jq-sand', className)}
      {...props}
    />
  ),
);
Skeleton.displayName = 'Skeleton';

interface TableSkeletonProps {
  rows?: number;
  columns: number;
  /** Optional per-column Tailwind width classes (defaults applied if missing). */
  cellWidths?: string[];
}

function TableSkeleton({ rows = 5, columns, cellWidths }: TableSkeletonProps) {
  const widths = React.useMemo(
    () => Array.from({ length: columns }, (_, i) => cellWidths?.[i] ?? 'w-3/4 max-w-[180px]'),
    [columns, cellWidths],
  );

  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: decorative skeleton rows are static
        <TableRow key={`skeleton-row-${r}`} className="hover:bg-transparent">
          {widths.map((width, c) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: decorative skeleton cells are static
            <TableCell key={`skeleton-cell-${r}-${c}`}>
              <Skeleton className={cn('h-4', width)} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export { Skeleton, TableSkeleton };
